import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface NotificationStore {
  cache: Record<string, any[]>
  timestamps: Record<string, number>
  setCache: (type: string, data: any[]) => void
  getCache: (type: string) => any[] | undefined
  getLastFetched: (type: string) => number | undefined
  clear: () => void
}

export const useNotificationStore = create<NotificationStore>()(
  persist(
    (set, get) => ({
      cache: {},
      timestamps: {},
      setCache: (type, data) => {
        const now = Date.now()
        set(state => ({
          cache: { ...state.cache, [type]: data },
          timestamps: { ...state.timestamps, [type]: now }
        }))
      },
      getCache: type => get().cache[type],
      getLastFetched: type => get().timestamps[type],
      clear: () => set({ cache: {}, timestamps: {} }),
    }),
    {
      name: 'notification-cache',
      partialize: (state) => ({
        cache: state.cache,
        timestamps: state.timestamps
      }),
    }
  )
)
